import { CurrencyEnum } from '@spectrocoin/sc-currencies';
import { createContext } from 'react';
import DonationAddress from '../../../interfaces/DonationAddress';
import { DonationStage } from '../../../redux/DonationSlice/DonationSlice';
import { RemoteData, RemoteStatus } from '../../../redux/SharedTypes';

export default createContext<{
	stage: DonationStage;
	setStage: (value: DonationStage) => void;
	address: RemoteData<DonationAddress>;
	setAddress: (value: RemoteData<DonationAddress>) => void;
	createAddress: (currency: CurrencyEnum) => Promise<void>;
}>({
	stage: DonationStage.None,
	setStage: () => {},
	address: { status: RemoteStatus.None },
	setAddress: () => {},
	createAddress: async () => {},
});
